"use strict";
var $ = require("../internals/export");
var IS_PURE = require("../internals/is-pure");
var NativePromiseConstructor = require("../internals/promise-native-constructor");
var fails = require("../internals/fails");
var getBuiltIn = require("../internals/get-built-in");
var isCallable = require("../internals/is-callable");
var speciesConstructor = require("../internals/species-constructor");
var promiseResolve = require("../internals/promise-resolve");
var defineBuiltIn = require("../internals/define-built-in");
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var NON_GENERIC = !!NativePromiseConstructor && fails(function() {
  NativePromisePrototype["finally"].call({ then: function() {
  } }, function() {
  });
});
$({ target: "Promise", proto: true, real: true, forced: NON_GENERIC }, {
  "finally": function(onFinally) {
    var C = speciesConstructor(this, getBuiltIn("Promise"));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function(x) {
        return promiseResolve(C, onFinally()).then(function() {
          return x;
        });
      } : onFinally,
      isFunction ? function(e) {
        return promiseResolve(C, onFinally()).then(function() {
          throw e;
        });
      } : onFinally
    );
  }
});
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn("Promise").prototype["finally"];
  if (NativePromisePrototype["finally"] !== method) {
    defineBuiltIn(NativePromisePrototype, "finally", method, { unsafe: true });
  }
}
